import * as React from 'react';
import { Stack, Typography } from '@mui/material';
import { User as UserIcon } from '@phosphor-icons/react';

import type { User } from '@/types/v2/user';
import { ProfessionalDialog } from '@/components/common';

import { CreateOrEditResidentForm } from './create-or-edit-resident-form';

interface CreateOrEditResidentModalProps {
  open: boolean;
  onClose: () => void;
  onSuccess: (user: User) => void;
  mode: 'create' | 'edit';
  initialData?: {}; // Change from Community | {} to just Community
  userId?: string;
  communityId?: string;
}

export function CreateOrEditResidentModal({
  open,
  onClose,
  onSuccess,
  mode,
  initialData,
  userId,
  communityId,
}: CreateOrEditResidentModalProps): React.JSX.Element {
  const handleClose = React.useCallback(() => {
    onClose();
  }, [onClose]);

  const handleSuccess = React.useCallback(
    (user: User) => {
      onSuccess(user);
      handleClose();
    },
    [onSuccess, handleClose]
  );

  return (
    <ProfessionalDialog
      contentSx={{ display: 'flex', flexDirection: 'column', gap: 2, minHeight: 0 }}
      icon={<UserIcon size={24} />}
      maxWidth="md"
      onClose={onClose}
      open={open}
      subtitle={
        mode === 'create'
          ? 'Users are the people who live in your community.'
          : 'Editing a user allows for modifications to user details and permissions, improving user management and ensuring accurate information. Users can be property managers or residents, and all users on the platform will be listed here.'
      }
      title={mode === 'create' ? 'Create User' : 'Edit User'}
      variant="modern"
    >
      <CreateOrEditResidentForm
        communityId={communityId}
        initialData={initialData as User}
        mode={mode}
        onSuccess={handleSuccess}
        userId={userId}
      />
    </ProfessionalDialog>
  );
}
